// Generated by https://quicktype.io

import { OOMenuItem } from "./oo-menu-item";

export class SalesSummary {
	venueKey: number;
	checkDate: string;
	lastPollDateTime: string;
	advanceAmount: number;
	averageCheck: number;
	averageGuest: number;
	averageTime: number;
	checkCount: number;
	countdownItemsCount: number;
	depositAmount: number;
	depositCount: number;
	discountAmount: number;
	discountCount: number;
	firstCheckOfDayTime: string;
	firstClockInName: string;
	firstClockInTime: string;
	giftCardAmount: number;
	giftCardCount: number;
	guestCount: number;
	laborCost: number;
	laborPercentage: number;
	missingBeverageCount: number;
	netCash: number;
	netSales: number;
	openCheckCount: number;
	outOfStockItemsCount: number;
	paidoutAmount: number;
	paidoutCount: number;
	refundAmount: number;
	refundCount: number;
	reopenedCheckCount: number;
	returnItemAmount: number;
	returnItemCount: number;
	safeReportBalanceDue: number;
	safeReportBankDeposits: number;
	safeReportCashCountTotal: number;
	safeReportChangeOrders: number;
	safeReportDrawerTillsAdd: number;
	safeReportOverShort: number;
	safeReportPettyCashUnloaded: number;
	safeReportPriorDaySafeCount: number;
	safeReportSafeCount: number;
	tipFee: number;
	trackingItemsCount: number;
	variablePriceItemsCount: number;
	variablePriceItemsSales: number;
	voidAmount: number;
	voidCount: number;

	mealPeriodSummary: MealPeriodSummary[];

	orderTypeSummary: OrderTypeSummary[];

	reportGroupSummary: ReportGroupSummary[];

	laborHourSummary: LaborHourSummary[];

	laborJobSummary: LaborJobSummary[];

	itemSummary: VenueSalesItemSummary[];

	previousDaySales: {
		checkDate: string;
		netSales: number;
		laborCost: number;
		laborPercentage: number;
		averageCheck: number;
		averageGuest: number;
		guestCount: number;
		checkCount: number;
		averageTime: number;
	}[];

	averages: {
		averageNetSales: number;
		netSalesCalculationDays: number;
		averageLaborCost: number;
		laborCostCalculationDays: number;
		averageLaborPercentage: number;
		laborPercentageCalculationDays: number;
		averageCheck: number;
		checkCalculationDays: number;
		averageGuest: number;
		guestCalculationDays: number;
		averageGuestCount: number;
		guestCountCalculationDays: number;
		averageCheckCount: number;
		checkCountCalculationDays: number;
		averageTime: number;
		timeCalculationDays: number;
	};

	public constructor(init?: Partial<SalesSummary>) {
		Object.assign(this, init);
	}
}

export class CountdownItem {
	name: string;
	count: number;
}

export class LaborHourSummary {
	cost: number;
	checks: number;
	hour: number;
	sk: string;
	guests: number;
	interval: string;
	startTime: string;
	laborPercentage: number;
	pk: string;
	endTime: string;
	units: number;
	sales: number;
}

export class LaborJobSummary {
	jobName: string;
	cost: number;
	laborGroupId: string;
	percentageOfLabor: number;
	sk: string;
	laborPercentage: number;
	pk: string;
	id: number;
	chartColor?: string;
}

export class MealPeriodSummary {
	averageCheck: number;
	averageGuest: number;
	intervals: Interval[];
	checks: number;
	guests: number | string;
	sk: string;
	name?: string;
	startTime?: string;
	pk: string;
	id?: number;
	endTime?: string;
	sales?: number;
	chartColor: string;
}

export class Interval {
	averageCheck: number;
	averageGuest: number;
	name: string;
	guests: number;
	startTime: string;
	endTime: string;
	sales?: number;
	chartColor: string;
}

export class OrderTypeSummary {
	orderTypeCharges: number;
	sk: string;
	count: number;
	name: string;
	tipped: boolean;
	pk: string;
	id: number;
	sales: number;
	chartColor: string;
}

export class GenericNameId {
	name: string;
	id: string;
}

export class ReportGroupSummary {
	superGroup?: GenericNameId;
	nonSales: boolean;
	sk: string;
	count: number;
	name: string;
	pk: string;
	id: number;
	percent: number;
	sales: number;
	chartColor: string;
}

export class VenueSalesItemSummary {
	checkDate: string;
	checkInstances: number;
	checkKeys: string[];
	cost: number;
	menuItem: OOMenuItem;
	menuItemKey: number;
	name: string;
	quantity: number;
	revenue: number;
}
